import httpClient from '../axios';

const URL = 'executives';

const executives = async (data) => httpClient.post(URL, data);

export default executives;
